const SERVER_FIELD_MAP = {
  nick: 'nick',
  email: 'email',
}

export function mapSignupServerErrors (errors, setError) {
  if (!errors || typeof errors !== 'object') return []

  const errorKeys = Object.keys(errors)

  errorKeys.forEach((field) => {
    const formField = SERVER_FIELD_MAP[field] || field
    const errorTypeKey = Object.keys(errors[field])[0]
    const message = errors[field][errorTypeKey]

    if (message && setError) {
      setError(formField, { type: 'server', message })
    }
  })

  return errorKeys
}

export function mapFacebookRegisterServerErrors (errors) {
  if (!errors || typeof errors !== 'object') return {}

  return Object.keys(errors).reduce((acc, key) => {
    const errorTypeKey = Object.keys(errors[key])[0]
    acc[key] = errors[key][errorTypeKey]
    return acc
  }, {})
}
